import React from 'react';
import { Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const UpdateAsplCard = () => {
  return (
    <Card className="shadow-sm border-0 h-100">
      <Card.Body className="d-flex flex-column justify-content-between">
        <div>
          <Card.Title>Manage ASPL Products</Card.Title>
          <Card.Text className="text-muted mb-0">
            Edit ASPL product details, USD prices, and keep NGN conversion synced.
          </Card.Text>
        </div>
        <div className="mt-3">
          <Link to="/dashboard/aspl-prices" style={{ textDecoration: 'none', fontWeight: 'bold', color: '#007bff' }}>
            Update ASPL Products →
          </Link>
        </div>
      </Card.Body>
    </Card>
  );
};

export default UpdateAsplCard;
